import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import LitoChatPage from './components/LitoChatPage';
import { LITO_PAGE_PARAM, parseLitoCode } from './services/centralChat';
import reportWebVitals from './reportWebVitals';

// /?lito=IM123 opens the full-page Lito chat instead of the map
const params = new URLSearchParams(window.location.search);
const isLitoPage = params.has(LITO_PAGE_PARAM);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isLitoPage ? <LitoChatPage code={parseLitoCode(params.get(LITO_PAGE_PARAM))} /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
